import AddIcon from "@mui/icons-material/Add";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import { memo } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { BUTTON_HOVER } from "styles/colors";

function Actions() {
  const navigate = useNavigate();
  const device = useParams().device;
  return (
    <Box py={1} sx={containerStyles}>
      <Button
        size="large"
        variant="contained"
        startIcon={<AddIcon />}
        onClick={() => navigate(`create/${device}`)}
      >
        Add New
      </Button>
    </Box>
  );
}

export default memo(Actions);

const containerStyles = {
  display: "flex",
  justifyContent: "space-between",
  alignItems: "center",
  "& .MuiOutlinedInput-root": {
    "&:hover": {
      backgroundColor: BUTTON_HOVER,
    },
  },
  "& .MuiSelect-select": { height: "29px !important" },
};
